import { withStyles } from '@material-ui/styles';

import IntegrationButton from './IntegrationButton';
import styles from './styles';

export default withStyles(styles)(IntegrationButton);
